import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { TopBarLanding } from '../../components/TopBars/TopBarLanding';

import { Button, Card, CardContent, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { ToggleButtonCustom } from './ToggleButton';
import { PricingPlans } from './PricingPlans';
import { SignUp } from '../landing/SignUp/SignUp';
import { TopBarSignedIn } from '../../components/TopBars/TopBarSignedIn';
import { PricingPlansDiscounts } from './PricingPlansDiscounts';
import { Footer } from '../../components/Footer/Footer';

export function Payment(props) {
	const { isAuthenticated, bankroll, setBankroll, setFiltersOpen, user, filtersOpen, isMobile, onboarding, onPlanSelected } = props;

	const [paymentCycle, setPaymentCycle] = useState('BiWeekly');
	const scrollToRegion = () => {
		const hash = window.location.hash;
		if (hash) {
			const element = document.querySelector(hash);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
			}
		}
	};
	const [isSigningUp, setIsSigningUp] = useState(false);

	return (
		<div>
			<Helmet>
				<title>Pricing | WagerWiz +EV, Arbitrage & Odds Tools</title>
				<meta name="description" content="Simple pricing for WagerWiz. Unlock the full +EV scanner, arbitrage finder, advanced filters, and real-time odds across 20+ sportsbooks." />
				<link rel="canonical" href="https://www.thewagerwiz.com/pricing" />
				<meta property="og:title" content="WagerWiz Pricing" />
				<meta property="og:description" content="Simple pricing for WagerWiz. Unlock the full +EV scanner, arbitrage finder, and advanced tools." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://www.thewagerwiz.com/pricing" />
				<meta property="og:site_name" content="WagerWiz" />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content="WagerWiz Pricing" />
				<meta name="twitter:description" content="Simple pricing for WagerWiz. Unlock the full +EV scanner, arbitrage finder, and advanced tools." />
			</Helmet>
			<div style={{ flex: 1 }}>
				{!onboarding && (
					<>
						{!isAuthenticated ? (
							<TopBarLanding isMobile={isMobile} scrollToRegion={scrollToRegion} setIsSigningUp={setIsSigningUp} isSigningUp={isSigningUp} />
						) : (
							<TopBarSignedIn isMobile={isMobile} bankroll={bankroll} setBankroll={setBankroll} email={user?.email} filtersOpen={filtersOpen} setFiltersOpen={setFiltersOpen} />
						)}
					</>
				)}

				{isSigningUp && <SignUp login={() => {}} />}
				{/* <stripe-pricing-table
				pricing-table-id="prctbl_1QvuHbRs9Kxk3FYqGMSgUu8Z"
				publishable-key="pk_test_51QiNskRs9Kxk3FYq1G9RRLSQ6lyD4RIljY3Sex8Bp2g59vGzJ8Zob8OBP0UXqjPq649eGBevSGHpIulnyM0CZTxN00SVAGNVX8"></stripe-pricing-table> */}
				{!isSigningUp && (
					<div className="flex flex-col items-center text-white bg-[#101826]">
						<div className="mt-6">
							<Typography sx={{ fontFamily: 'Avenir', fontWeight: 'bold', fontSize: 40, textAlign: isMobile && 'center' }} variant="h4" className="mb-2">
								More value. More wins.
							</Typography>
						</div>
						<div className="mt-4">
							<Typography sx={{ fontFamily: 'Avenir', fontWeight: 'bold', textAlign: isMobile && 'center' }} variant="body1" className="mb-4 p-4">
								Choose a plan that fits your betting style and start making sharper plays today.
							</Typography>
						</div>
						<div className="mt-4">
							<ToggleButtonCustom setPaymentCycle={setPaymentCycle} paymentCycle={paymentCycle} />
						</div>

						<div className="flex flex-wrap justify-center gap-4">
							{/* <PricingPlans paymentCycle={paymentCycle} /> */}
							<PricingPlansDiscounts paymentCycle={paymentCycle} onPlanSelected={onPlanSelected} />
						</div>
					</div>
				)}
			</div>
			<Footer />
		</div>
	);
}
